/**
 * Created by Alex Aguilar on 5/16/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('itineraryFlightService', itineraryFlightService)

    itineraryFlightService.$inject = ['$http', 'CONFIG', 'messageService'];


    function itineraryFlightService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/routeItineraries';
        var service = {
            saveItineraryFlight: saveItineraryFlight,
            updateRouteItinerary: updateRouteItinerary,
            getRouteItinerary: getRouteItinerary,
            deleteRouteItinerary: deleteRouteItinerary,
            getLoadFormRouteItinerary: getLoadFormRouteItinerary,
            getRouteItineraries: getRouteItineraries,
            getRouteItinerariesPageByItinerary: getRouteItinerariesPageByItinerary,
            getPositionItineraryFlightDepartures: getPositionItineraryFlightDepartures
        };

        return service;

        function saveItineraryFlight(routeItinerary){
            return $http.post(urlBase, routeItinerary)
                .then(saveComplete)
                .catch(getFailed);

            function saveComplete(){
                messageService.register('');
            }
            function getFailed(){
                messageService.registerError('');
            }
        }

        function updateRouteItinerary(routeItinerary, routeItineraryId){
            return $http.put(urlBase + "/" + routeItineraryId, routeItinerary)
                .then(function(){
                    messageService.registerUpdate('');
                }, function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('','air.itineraryFlight.associatedConnections')
                    }else{
                        messageService.registerUpdateError('')
                    }
                });
        }

        function getRouteItinerary(itineraryId){
            return $http.get(urlBase + '/' + itineraryId)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return response;
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function deleteRouteItinerary(itineraryId){
            return $http.delete(urlBase + '/' + itineraryId)
                .then(function(){
                    messageService.registerDelete('');
                }, function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('','air.itineraryFlight.associatedConnections')
                    }else{
                        messageService.registerDeleteError('')
                    }
                });
        }

        function getLoadFormRouteItinerary(){
            return $http.get(urlBase + '/loadForm')
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return response;
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function getRouteItineraries(){
            return $http.get(urlBase + '/');
        }

        function getRouteItinerariesPageByItinerary(itineraryId, page, size){
            return $http.get(urlBase + '/byItinerary/'+itineraryId+'?page=' + page + '&size=' + size)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return response;
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function getPositionItineraryFlightDepartures(itineraryFlightDepartures, dayCode) {
            var pos = -1;
            for (var i = 0; i < itineraryFlightDepartures.length; i++) {
                var itineraryFlightDeparture = itineraryFlightDepartures[i];
                if(itineraryFlightDeparture.day.code === dayCode) {
                    pos = i;
                    break;
                }
            }
            return pos;
        }
    }
})();
